import { useWindowDimensions } from 'react-native';
import THEME from '../../config/theme';
import { useCustomTheme } from '../../contexts/useCustomTheme';

// Tipografia compartilhada pela lista de comentários (cabeçalho, comentário e
// resposta) — antes cada um dos três montava a mesma lista de constantes.
//
// Os tamanhos vêm do tema do cliente (`customFont`), que é calibrado para texto
// corrido. Numa lista de comentários no celular isso fica grande demais e cabe
// pouquíssima conversa na tela, então no mobile cada tamanho ganha um teto.

const MOBILE_BREAKPOINT = 768;

export function useCommentTypography() {
  const { width } = useWindowDimensions();
  const { customFont } = useCustomTheme();

  const isSmallScreen = width < MOBILE_BREAKPOINT;
  const cap = (value, max) => (isSmallScreen ? Math.min(value, max) : value);

  return {
    isSmallScreen,
    fontTitle: customFont?.fontFamilySubtitle || THEME.FONTFAMILY.MEDIUM,
    fontText: customFont?.fontFamilyText || THEME.FONTFAMILY.REGULAR,
    // Título "Comentários" — um degrau acima do corpo, não um título de página.
    fontMD: cap(customFont?.fontMD || THEME.FONTSIZE.MEDIUM, 15),
    // Nome do autor e corpo do comentário.
    fontSM: cap(customFont?.fontSM || THEME.FONTSIZE.SMALL, 14),
    // Data, "Responder", contadores.
    fontXS: cap(customFont?.fontXS || THEME.FONTSIZE.EXTRASMALL, 12),
    lineHeight: isSmallScreen ? 19 : 22,
  };
}

export default useCommentTypography;
